import CheckIcon from '../../Utility/CheckIcon';
import { RootState, useAppSelector } from '../../../store';

interface ConfigItem {
    identifier: string;
    title: string;
    description: string;
    config?: any;
    deprecated?: boolean;
}

interface ConfigSelectorItemProps {
    item: ConfigItem;
    isSelected: boolean;
    onToggle: (itemId: string, identifierOfConfig: string) => void;
}

function ConfigSelectorItem({ item, isSelected, onToggle }: ConfigSelectorItemProps) {
    const i18n = useAppSelector((state: RootState) => state.i18n.i18n);

    const deprecatedText = i18n.translate({ id: 'selectorItem.deprecated', sourceName: 'PromptFunction' });
    return (
        <div
            key={item.identifier}
            onClick={() => onToggle(item.identifier, item.config?.identifier)}
            className={`relative px-3 py-2 border-2 hover:border-primary w-full overflow-hidden rounded-xl h-[80px] flex items-center cursor-pointer border-layout-borderColor ${
                isSelected ? 'border-primary' : 'border-layout-borderColor hover:border-primary'
            }`}
        >
            <div className="flex-1 min-w-0 flex flex-col justify-center gap-1">
                <div className="font-medium">
                    {item.deprecated ? (
                        <i>
                            {item.title} ({deprecatedText})
                        </i>
                    ) : (
                        item.title
                    )}
                </div>
                <div className="flex items-center gap-2">
                    <span className="line-clamp-1 text-gray-500 text-sm min-w-0">{item.description}</span>
                </div>
            </div>
            {isSelected && <CheckIcon />}
        </div>
    );
}

export default ConfigSelectorItem;
